import { Box, Stack } from '@mui/material';
import React from 'react';
import { IContestAward } from '../../types/global/helper';
import { PersonCard } from './PersonCard';
import { isEmpty } from '../../utils/lodash';
import { useThemeContext } from '../../hook/useThemeManager';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { Wreathe } from '../Wreathe/Wreathe';

interface IPersonSuggestionGroup {
    awardList?: IContestAward[];
    kind?: 'award' | 'user';
}
export const PersonSuggestionGroup: React.FC<IPersonSuggestionGroup> = ({ kind, awardList }) => {
    const { themeStyle } = useThemeContext();
    return (
        <Stack width={'100%'}>
            <Stack direction="row" gap={1} alignItems={'center'}>
                <Wreathe
                    withImage={false}
                    imageStyle={{ width: 120, height: 120 }}
                    text={'Staff Pick'}
                    mode={themeStyle}
                    textStyle={{
                        fontFamily: FONT_ENUM.MAIN_BOLD,
                        fontSize: 12,
                    }}
                />
            </Stack>
            <Box
                style={{
                    width: '100%',
                    height: 'auto',
                    gap: '5px',
                }}>
                {awardList &&
                    !isEmpty(awardList) &&
                    awardList.slice(0, 1).map((item, index) => <PersonCard key={index} award={item} />)}
            </Box>
        </Stack>
    );
};
